import React from "react";

export const isLogin = () => {
  if (localStorage.getItem('webKey')) {
    if (localStorage.getItem('webKey') === "udefined") {
      return false;
    }
    return true;
  }
  return false;
};
